module.exports = __webpack_public_path__ + "static/media/Thin and Lightweight Icon.be0c101e.png";